import { render, staticRenderFns } from "./LinkSetting.vue?vue&type=template&id=60e7dd78&scoped=true"
import script from "./LinkSetting.vue?vue&type=script&lang=js"
export * from "./LinkSetting.vue?vue&type=script&lang=js"
import style0 from "./LinkSetting.vue?vue&type=style&index=0&id=60e7dd78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e7dd78",
  null
  
)

export default component.exports